export const CONTACT_FORM_NAME = 'ContactForm';
export const CONTACT_FORM = 'CONTACT_FORM';
export const CONTACT_FORM_VALIDATION_FIELDS = ['phoneNumber', 'emailAddress'];
